import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

/**
 * AGRUPA UN CONJUNTO DE FUNCIONES QUE SE PUEDEN CONSIDERAR
 * COMO VALIDADORES AL MOMENTO DE INGRESAR INFORMACIÓN UN
 * FORMULARIO.
 *
 * La nomemclatura para lo nombres es 'validate', seguido
 * del nombre de la función en camel-case
 *
 * @export
 * @class ValidatorService
 */
@Injectable()

export class ValidatorService {

    // -----------------------------------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------------------------------
    constructor() {

    }

	/**
	 * SECTION TO ADD FORM GROUP VALIDATORS
	 *
	 * @param {FormControl} c
	 * @returns
	 * @memberof FunctionService
	 */
    validateEmail(c: FormControl) {
        let EMAIL_REGEXP = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return EMAIL_REGEXP.test(c.value) ? null : {
            valid: false,
            message: "Formato de correo no válido"
        };
    }

	/**
	 * Valida formato de telefono para telefono local y celular
	 * @param c control form var
	 */
    validatePhone(c: FormControl) {
        let REGEX = /^((?:[+])?[0-9]+(?:[ /.,|-]?[(]?[ 0-9][)]?)+)$/;
        return REGEX.test(c.value) ? null : {
            valid: false,
            message: 'Formato de número teléfonico no válido',
        }
    }

	/**
	 * Validate a value is positive
	 * @param c control from variable to validate
	 */
    validatePositiveValue(c: FormControl) {
        if (c.value >= 0) {
            return null
        } else {
            return {
                valid: false,
                message: 'No se admiten valores negativos o iguales a cero',
            }
        }
    }

	/**
	 * Validate a value contains only numbers
	 * @param c Form Control to check value
	 */
    validateOnlyNumbers(c: FormControl) {
        var isnum = /^\d+$/.test(c.value);
        if (isnum) {
            return null
        } else {
            return {
                valid: false,
                message: 'Solo se admiten números'
            }
        }
    }

	/**
	 * Valida que la contraseña tengo 8 o más caracteres
	 * @param c Form control to check Value
	 */
    validatePasswordLength(c: FormControl) {
        if (String(c.value).length >= 8) {
            return null
        } else {
            return {
                valid: false,
                message: 'La contraseña debe ser mayor igual a 8 caracteres'
            }
        }
    }

    validAutocomplete(control: FormControl): ValidationErrors | null {
        const err = {
            autocompleteError: {
                err: 'Invalid option'
            }
        }
        const objValue = control.value
        if (typeof (objValue) == "object") {
            if (objValue.id > 0) {
                return null
            } else {
                return err
            }
        } else {
            return err
        }
    }

    /**
     * Verifica que el formato de fecha sea estrictamente 'YYYY-MM-DD'
     * @param control
     */
    validDateYYYYMMDD(control: FormControl): Error | null {
        let e = {} as Error
        e.valid = /^\d{4}-\d{2}-\d{2}/.test(control.value)
        if (e.valid) {
            return null
        } else {
            e.message = 'El formato de fecha no es válido'
        }
        return e
    }

    /**
     * Valida que una string contenga solo letras, puntos, postrofres o guiones
     * @param c control
     */
    validName(c: FormControl): Error | null {
        let e = {} as Error
        e.valid = /^^[\p{L}\s'.-]+$/.test(c.value)
        console.log(e)
        if (e.valid) {
            return null
        } else {
            e.message = 'Debe contener solo letras, puntos, apostrofes o guiones'
        }
        return e
    }
}

interface Error {
    valid: boolean;
    message: string;
}



// WEBPACK FOOTER //
// ./src/app/services/validators/validator.service.ts